import { createContext, FC, useState } from 'react';
import { getLocalStorage } from '../utils/web-storage-utils';

export type VBType = 'blur' | 'none';
type DeviceSetting = {
  activeCamera: string;
  activeMicrophone: string;
  activeSpeaker: string;
  isStartedVideo: boolean;
  isStartedAudio: boolean;
  virtualBackground: VBType & string;
};
export type DeviceSettingContextProps = DeviceSetting & {
  updateDeviceSetting: React.Dispatch<React.SetStateAction<DeviceSetting>>;
};

export const DeviceSettingContext = createContext<DeviceSettingContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const DeviceSettingProvider: FC<Props> = ({ children }) => {
  const [deviceSetting, setDeviceSetting] = useState<DeviceSetting>({
    activeCamera: 'default',
    activeMicrophone: 'default',
    activeSpeaker: 'default',
    isStartedAudio: false,
    isStartedVideo: false,
    virtualBackground: (() => {
      const vb = getLocalStorage('VirtualBackground') as VBType;
      const map: { [key in VBType]: VBType } = {
        blur: 'blur',
        none: 'none'
      };
      if (vb in map) {
        return map[vb]!;
      } else {
        return 'none';
      }
    })()
  });

  return (
    <DeviceSettingContext.Provider
      value={{
        ...deviceSetting,
        updateDeviceSetting: setDeviceSetting
      }}
    >
      {children}
    </DeviceSettingContext.Provider>
  );
};
export default DeviceSettingProvider;
